const checkClasses = [".content-wrap", ".service-item-text-val", `[class*="slider-slide-text"]`]

function wrapAsterisksInBold() {
  checkClasses.forEach(className => {
      const items = document.querySelectorAll(className);
      items.forEach(item => {
        item.innerHTML = item.innerHTML.replace(/\*(.*?)\*/g, '<b>$1</b>');
      });
  })
}

function initObserverForBoldAsterisks() {
  const observer = new MutationObserver(() => {
    const items = document.querySelectorAll('.service-item-text-val');
    if (items.length > 0) {
      wrapAsterisksInBold();
      observer.disconnect(); // Stop observing once items are found and updated
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/products/')) {
    initObserverForBoldAsterisks();
  }
});